export const initialState = {
    products: [],
    mensProducts: [],
    womensProducts: [],
    unisexProducts: [],
    featuredProducts: [],
    loading: false,
    error: null,
};

export const productReducer = (state, action) => {
    switch (action.type) {
        case "FETCH_START":
            return {
                ...state,
                loading: true,
                error: null,
            };

        case "FETCH_SUCCESS":
            const products = action.payload;

            return {
                ...state,
                loading: false,
                products,
                mensProducts: products.filter((p) => Number(p.type) === 1),
                womensProducts: products.filter((p) => Number(p.type) === 2),
                unisexProducts: products.filter((p) => Number(p.type) === 3),
                featuredProducts: products.filter((p) => Number(p.featured) === 1),
            };

        case "FETCH_ERROR":
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        default:
            return state;
    }
};

